import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { className: "w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { className: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { className: "fw-bolder text-dark" }, "Current Job"),
  /*#__PURE__*/_createElementVNode("div", { className: "text-gray-400 fw-bold fs-6" }, [
    /*#__PURE__*/_createTextVNode(" If you need more info, please check out "),
    /*#__PURE__*/_createElementVNode("a", { className: "link-primary fw-bolder" }, "Help Page"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_3 = { className: "fv-row mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { className: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Company You Work For")
], -1)
const _hoisted_5 = { className: "fv-row mb-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { className: "form-label" }, "Level Of Seniority", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { className: "fv-row mb-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { className: "form-label" }, "Active Industry", -1)
const _hoisted_10 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Field, {
        name: "company",
        class: "form-control form-control-lg form-control-solid"
      }),
      _createVNode(_component_ErrorMessage, {
        name: "company",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_component_Field, {
        name: "levelOfSeniority",
        class: "form-select form-select-lg form-select-solid",
        "data-control": "select2",
        "data-placeholder": "Select...",
        "data-allow-clear": "true",
        "data-hide-search": "true",
        as: "select"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seniorityLevels, (level) => {
            return (_openBlock(), _createElementBlock("option", {
              key: level.id,
              value: level.id
            }, _toDisplayString(level.name), 9, _hoisted_7))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_ErrorMessage, {
        name: "levelOfSeniority",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(_component_Field, {
        name: "activeIndustry",
        class: "form-select form-select-lg form-select-solid",
        "data-control": "select2",
        "data-placeholder": "Select...",
        "data-allow-clear": "true",
        "data-hide-search": "true",
        as: "select"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allIndustries, (industry) => {
            return (_openBlock(), _createElementBlock("option", {
              key: industry.id,
              value: industry.id
            }, _toDisplayString(industry.name), 9, _hoisted_10))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_ErrorMessage, {
        name: "activeIndustry",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ])
  ]))
}